import { createContext, useState } from 'react';

const PreviewContext = createContext({
  formValues: {
    id: ''
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  setForm: (values: any) => {}
});

const PreviewProvider = ({ children } : any) => {
  const [formValues, setformValues] = useState(
    {
      id: ''
    }
  );
  
  const setForm = (values: any) => {
    setformValues(values);
  };

  return <PreviewContext.Provider value={{formValues, setForm}}>
    {children}
  </PreviewContext.Provider>;
};

PreviewProvider.context = PreviewContext;

export default {PreviewProvider};